
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/smart-contract-development",
      function () {
        return require("private-next-pages/services/smart-contract-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/smart-contract-development"])
      });
    }
  